
import { Box, Button, Paper, Text, Title, createStyles } from "@mantine/core";
import { NewNote } from "./NewNote";

const useStyles = createStyles(() => ({
  default: {
    borderRadius: "8px",
    marginLeft: "40px",
    marginRight: "40px",
    padding: "16px",
    marginTop: "16px",
  },
  heading: {
    fontWeight: 700,
    fontSize: "26px",
    lineHeight: "36px",
    color: "#262930",
  },
}));


export const NewClinicalNotes = () => {
  const { classes } = useStyles();

  return (
   <Box>
   <NewNote edit={false}/>
   </Box>
  );
};
export default NewClinicalNotes